import { ReactNode } from "react"
import {
  articleBodyStyle,
  articleFaqBodyStyle,
  articleImageStyle,
  designGuideNav,
  designGuideNavList,
  faqGrid,
  faqH3Style,
  figCaptionStyle,
  h1Style,
  h2Style,
  h3Style,
  stepSectionStyle,
  unorderedList,
} from "~/routes/article.css"
import { page } from "~/shared/styles.css"
import { golden, vars } from "~/components/styles/theme.css"
import { articleCompareImages, bold } from "~/routes/article.css"
import LinkButton from "../LinkButton"
import { btnWrap } from "~/routes/index.css"
import Link from "../Link"

export const P = ({ children }: { children: ReactNode }) => {
  return <p className={articleBodyStyle}>{children}</p>
}

export const Section = ({ children }: { children: ReactNode }) => {
  return <section className={stepSectionStyle}>{children}</section>
}

export const Page = ({ children }: { children: ReactNode }) => {
  return <div className={page}>{children}</div>
}

export const H1 = ({ children }: { children: ReactNode }) => {
  return <h1 className={h1Style}>{children}</h1>
}

export const H2 = ({ children }: { children: ReactNode }) => {
  return <h2 className={h2Style}>{children}</h2>
}

export const H3 = ({ children }: { children: ReactNode }) => {
  return <h3 className={h3Style}>{children}</h3>
}

export const Figure = ({
  src,
  caption,
  style = {},
  imgStyle = {},
}: {
  src: string
  caption: string
  style?: Record<string, string>
  imgStyle?: Record<string, string>
}) => {
  return (
    <figure style={style}>
      <img className={articleImageStyle} src={src} alt={caption} style={imgStyle} />
      <figcaption className={figCaptionStyle}>{caption}</figcaption>
    </figure>
  )
}

export const Image = ({ src, alt }: { src: string; alt: string }) => {
  return <img className={articleImageStyle} src={src} alt={alt} />
}

export const FAQGrid = ({ children }: { children: ReactNode }) => {
  return <div className={faqGrid}>{children}</div>
}

export const FAQItem = ({
  title,
  body,
  smaller,
}: {
  title: string
  body: string | ReactNode
  smaller?: boolean
}) => {
  return (
    <div>
      <h3
        className={faqH3Style}
        style={smaller ? { fontSize: `${golden * 0.8}rem` } : {}}
      >
        {title}
      </h3>
      <p
        className={articleFaqBodyStyle}
        style={{
          color: vars.color.light3,
          opacity: 0.8,
        }}
      >
        {body}
      </p>
    </div>
  )
}

type ImageT = {
  src: string
  alt: string
}

export const ImagePair = ({
  one,
  two,
  figcaption = null,
}: {
  one: ImageT
  two: ImageT
  figcaption?: string | null
}) => {
  if (figcaption) {
    return (
      <figure>
        <div className={articleCompareImages}>
          <img src={one.src} alt={one.alt} loading="lazy" />
          <img src={two.src} alt={two.alt} loading="lazy" />
        </div>
        <figcaption className={figCaptionStyle}>{figcaption}</figcaption>
      </figure>
    )
  }
  return (
    <div className={articleCompareImages}>
      <img src={one.src} alt={one.alt} loading="lazy" />
      <img src={two.src} alt={two.alt} loading="lazy" />
    </div>
  )
}

export const Bold = ({ children }: { children: ReactNode }) => (
  <strong className={bold}>{children}</strong>
)

export const ActionBtn = ({ children }: { children: string }) => (
  <div className={btnWrap} style={{ marginTop: `${3}rem` }}>
    <LinkButton url="/hello/signup" shouldPrefetch>
      {children}
    </LinkButton>
  </div>
)

export const GardenDesignGuideLink = ({
  href,
  title,
}: {
  href: string
  title: string
}) => <Link href={href}>{title}</Link>

export const GardenDesignGuideNav = ({
  left,
  right,
}: {
  left: ReactNode[]
  right: ReactNode[]
}) => {
  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <H3>Read More of the Design Guide</H3>
      <div className={designGuideNav}>
        <div className={designGuideNavList}>{left}</div>
        <div className={designGuideNavList}>{right}</div>
      </div>
    </div>
  )
}
